import { Theme, useMediaQuery } from "@material-ui/core";
import { TTList } from "@tt/ttms-react-core";
import jsonExport from "jsonexport/dist";
import moment from "moment";
import * as React from "react";
import { Datagrid, downloadCSV, Filter, ReferenceField, ReferenceInput, SelectInput, TextField, TextInput } from "react-admin";
import AuthorizedCheck from "../../components/Authorized/AuthorizedCheck";

const VideoFilter = (props) => {
  return (
    <Filter {...props}>
      <TextInput label="Title" source="title__contains" alwaysOn />
      <ReferenceInput label="Status" source="status__eq" reference="videostatuss" sort={{ field: "name", order: "ASC" }} alwaysOn>
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput label="Category" source="categoryId__eq" reference="categorys" sort={{ field: "name", order: "ASC" }} alwaysOn>
        <SelectInput optionText="name" />
      </ReferenceInput>
    </Filter>
  );
};

const VideoFilterSmall = (props) => {
  return (
    <Filter {...props}>
      <TextInput label="Title " source="title__contains" alwaysOn />
    </Filter>
  );
};

const VideoListTitle = () => {
  return <span>Video List</span>;
};

// const HtmlField = (props) => {
//     const { record, source } = props;
//     const html = record[source];
//     return <div dangerouslySetInnerHTML={{ __html: html }}></div>
// };

const exporter = (videos: any[]) => {
  const videosForExport = videos.map((item) => {
    return {
      Title: item.title,
      Status: item.videoStatus.name,
      Category: item.category.name, //,
      //"Chapter": item.chapterId
    };
  });

  jsonExport(
    videosForExport,
    { rowDelimiter: ";" },
    // , { headers: ["Title", "Status", "Category", "Chapter"] }
    (err: any, csv: any) => {
      if (err) return console.log(err);

      //UTF8
      const bom = "\uFEFF";
      downloadCSV(`${bom} ${csv}`, `VideoList-${moment().format("yyyMMDDHHmmss")}`);
    }
  );
};

const VideoList = (props) => {
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.between("xs", "md"));

  return (
    <AuthorizedCheck>
      <TTList
        resource="videos"
        {...props}
        filters={isSmall ? <VideoFilterSmall /> : <VideoFilter />}
        title={<VideoListTitle />}
        exporter={exporter}
        sort={{ field: "id", order: "DESC" }}
      >
        {isSmall ? (
          <Datagrid rowClick="edit">
            <TextField source="title" />
          </Datagrid>
        ) : (
          <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="title" />
            <ReferenceField label="Status" source="status" reference="videostatuss" link={false}>
              <TextField source="name" />
            </ReferenceField>
            <ReferenceField label="Category" source="categoryId" reference="categorys" link={false}>
              <TextField source="name" />
            </ReferenceField>
            {/* <HtmlField source="description" /> */}
          </Datagrid>
        )}
      </TTList>
    </AuthorizedCheck>
  );
};

export default VideoList;
